if(!customElements.get('pplx-care-tabs')){
 customElements.define('pplx-care-tabs',class extends HTMLElement{
  connectedCallback(){
   this.tabs=[...this.querySelectorAll('[data-care-tab]')];
   this.panels=[...this.querySelectorAll('[data-care-panel]')];
   this.abort?.abort();this.abort=new AbortController();
   const opt={signal:this.abort.signal};
   this.tabs.forEach((tab,i)=>{
    tab.addEventListener('click',()=>this.activate(tab),opt);
    tab.addEventListener('keydown',event=>{
     let next;
     if(event.key==='ArrowRight')next=this.tabs[(i+1)%this.tabs.length];
     if(event.key==='ArrowLeft')next=this.tabs[(i+this.tabs.length-1)%this.tabs.length];
     if(event.key==='Home')next=this.tabs[0];
     if(event.key==='End')next=this.tabs[this.tabs.length-1];
     if(next){event.preventDefault();this.activate(next);next.focus();}
    },opt);
   });
   this.addEventListener('shopify:block:select',event=>{
    const panel=event.target.closest('[data-care-panel]');
    if(panel){const tab=this.tabs.find(t=>t.dataset.careTab===panel.dataset.carePanel);if(tab)this.activate(tab);}
   },opt);
  }
  disconnectedCallback(){this.abort?.abort();}
  activate(tab){
   this.tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});
   this.panels.forEach(p=>{p.hidden=p.dataset.carePanel!==tab.dataset.careTab;});
  }
 });
}

// This asset loads only on the Complete Care template. Use Judge.me's existing
// all-reviews panel, never a fabricated aggregate or product-review count.
function careAllReviewsAnchor(){
 const carousel=document.querySelector('.jdgm-carousel-wrapper');
 if(carousel&&!document.getElementById('CareAllReviews')){
  const anchor=document.createElement('span');anchor.id='CareAllReviews';
  anchor.style.scrollMarginTop='140px';carousel.prepend(anchor);
 }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',careAllReviewsAnchor,{once:true});
else careAllReviewsAnchor();
document.addEventListener('click',event=>{
 const link=event.target.closest('[data-care-all-reviews]');
 if(!link)return;
 careAllReviewsAnchor();
 const button=document.querySelector('.jdgm-revs-tab-btn');
 if(button){
  event.preventDefault();
  const panel=document.querySelector('.jdgm-revs-tab .jdgm-all-reviews-widget-v2025');
  const rect=panel?.getBoundingClientRect();
  const open=rect&&rect.width>0&&rect.height>0&&rect.left<innerWidth&&rect.right>0&&getComputedStyle(panel).visibility!=='hidden'&&getComputedStyle(panel).display!=='none';
  if(!open)button.click();
 }
});
